import { useUserStore } from '@/stores/UserStore';

export const useHasRole = (requiredRole: string) => {
  const role = useUserStore((state) => state.role);
  return role === requiredRole;
};
